const validate = values => {
    const errors = {};
    return errors;
};

export default validate;
